;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import type { WorkspacePermissionResourceKey } from "@/lib/constants/workspace-permission-resources";
import {
	evaluatePermissionFlags,
	type HasResourcePermissionOptions,
	type PermissionFlagsArg,
} from "@/lib/utils/resource-permissions";
import type { UserData } from "@/types/user";
import type { Workspace, WorkspacePermission } from "@/types/workspace";

type WorkspacePermissionsMap = Workspace["permissions"];

export type WorkspacePermissionFlag = keyof WorkspacePermissionsMap[string];

/** Pass `"*"` to require at least one of the four flags to be effectively true (OR). */
export type WorkspacePermissionFlagsArg = PermissionFlagsArg;

export type WorkspacePermissionInput =
	| WorkspacePermissionsMap
	| WorkspacePermission[]
	| null
	| undefined;

export type HasWorkspacePermissionOptions = HasResourcePermissionOptions;

function getResourceBucket(
	permissions: WorkspacePermissionInput,
	resourceKey: WorkspacePermissionResourceKey,
): Partial<Record<WorkspacePermissionFlag, boolean>> | undefined {
	if (permissions == null) {
		return undefined;
	}

	if (Array.isArray(permissions)) {
		const row = permissions.find((entry) => entry.resource === resourceKey);
		if (!row) {
			return undefined;
		}

		return row;
	}

	return permissions[resourceKey];
}

/**
 * Whether the given permissions satisfy the requested flags for a resource.
 * Accepts `Workspace.permissions` (object) or `WorkspacePermission[]` (matches `resource` to `resourceKey`; first match wins if duplicated).
 * - Multiple flags: combined with **AND** (all must be effectively true).
 * - `"*"`: **OR** over all four flags — true if any is effectively true.
 * Missing resource or missing flag uses `defaultValue` (default false). Explicit `false` is never overridden.
 */
export function hasWorkspacePermission(
	permissions: WorkspacePermissionInput,
	resourceKey: WorkspacePermissionResourceKey,
	flagOrFlags: WorkspacePermissionFlagsArg,
	options?: HasWorkspacePermissionOptions,
): boolean {
	const defaultValue = options?.defaultValue ?? false;
	const bucket = getResourceBucket(permissions, resourceKey);

	return evaluatePermissionFlags(bucket, flagOrFlags, defaultValue);
}

/** Normalize organization permissions to workspace permissions */
export function normalizeOrganizationPermissions(
	organizationData: UserData | null,
): WorkspacePermission[] {
	const {
		createdAt = "",
		id = "",
		orgPermissions = [],
	} = organizationData ?? {};
	const createdAtDate = new Date(createdAt);

	return orgPermissions.map((permission) => ({
		...permission,
		createdAt: createdAtDate,
		id: `temp-${permission.name}`,
		resource: permission.name,
		updatedAt: createdAtDate,
		workspaceUserId: id,
	}));
}
